import { bookingStatus } from 'types/booking';
import { types as passengerTypes } from 'types/passengers';

export const LOYALTY_NUMBER_PREFIX = 308381100;
export const ADVANCED_PAX_INFO_DATE_FORMAT = 'YYYY-MM-DD';

export const INFANT_FIRST_NAME_KEY = 'infant_first_name';
export const INFANT_LAST_NAME_KEY = 'infant_last_name';
export const INFANT_UUID = 'infant_uuid';
export const INFANT_DETAIL_KEYS = [INFANT_FIRST_NAME_KEY, INFANT_LAST_NAME_KEY, INFANT_UUID];
export const INFANT_EDITABLE_BOOKING_STATUSES = [bookingStatus.CONFIRMED, bookingStatus.TEMPORARILY_ON_HOLD, bookingStatus.ON_HOLD];

export const ELIGIBLE_LAP_PASSENGER_TYPES = [passengerTypes.ADULT, passengerTypes.SENIOR, passengerTypes.YOUTH];
